module.exports = __webpack_public_path__ + "static/2-min-403f411ad1232d796f5e91ee0975247b.jpeg";